import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { normalizeError } from "@/store/helpers/errorHelper";

export interface ResidentInfo {
  errors: unknown;
}

@Module({ namespaced: true, name: "ResidentModule" })
export default class ResidentModule extends VuexModule implements ResidentInfo {
  errors = {};

  get getError() {
    const [errorName] = Object.keys(this.errors);
    const error = this.errors[errorName];
    return error;
  }

  @Mutation
  [Mutations.SET_ERROR](errorObj) {
    this.errors = normalizeError(errorObj);
  }

  @Action
  [Actions.DOWNLOAD_PDF_FORMS](id) {
    return ApiService.downloadFile(`/residents/${id}/download_pdf_forms`)
      .then((response) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return response;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
        throw response;
      });
  }

  @Action
  [Actions.GET_RESIDENT_BY_ID](id) {
    return ApiService.get(`/residents/${id}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return data;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
        throw response;
      });
  }

  @Action
  [Actions.UPDATE_RESIDENT](data) {
    const body = {
      roomNumber: data.roomNumber,
      fileNumber: data.fileNumber,
    };
    return ApiService.patch(`/residents/${data.residentId}`, body)
      .then((response) => {
        this.context.commit(Mutations.SET_ERROR, null);
        return response;
      })
      .catch(({ response, message }) => {
        this.context.commit(Mutations.SET_ERROR, { response, message });
        throw response;
      });
  }
}
